export default __webpack_public_path__ + "static/media/search.b93e612c.png";